import {HTMLAttributes} from 'react';

import styled, {css} from 'styled-components';

import {Display, FontFamily, FontSize, FontWeight, Spacing} from 'styles/Base';
import {Colors} from 'styles/Colors';
import {MarginProps, PaddingProps, generateMargins, generatePadding} from 'utils/components';

type TextProps = HTMLAttributes<HTMLHeadElement> & MarginProps & PaddingProps & {displayType?: Display};

const labelStyles = css<TextProps>`
  color: ${Colors.BROWN_GREY};
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  line-height: ${Spacing.ONE_5};
  display: ${({displayType}) => displayType || `${Display.INLINE_BLOCK}`};
`;

export const inputLabelStyle = css`
  ${labelStyles}
  font-size: ${FontSize.ONE};
`;

export const smallLabelStyle = css`
  ${labelStyles}
  font-size: ${FontSize.ZERO_8125};
`;

export const Label = styled.label<TextProps>`
  ${inputLabelStyle}
  ${(props: TextProps) => generateMargins(props)}
  ${(props: TextProps) => generatePadding(props)}
`;

export const SmallLabel = styled.label<TextProps>`
  ${smallLabelStyle}
  ${(props: TextProps) => generateMargins(props)}
  ${(props: TextProps) => generatePadding(props)}
`;
